import { render, staticRenderFns } from "./GetStudentInfo.vue?vue&type=template&id=60e3527c&"
import script from "./GetStudentInfo.vue?vue&type=script&lang=js&"
export * from "./GetStudentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports